import React from "react";
import Modal from "react-modal";

interface Props {
  closeModal: () => void;
}

Modal.setAppElement("body");

export const InterviewBookingHelpModal = ({
  closeModal,
}: Props): JSX.Element => {
  const customStyles = {
    overlay: {
      zIndex: 9999,
      backgroundColor: "rgba(9, 32, 36, 0.9)",
    },
    content: {
      background: "none",
      border: "none",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "0",
    },
  };

  return (
    <Modal isOpen={true} style={customStyles}>
      <div className='animated fadeIn fixed inset-0 overflow-y-auto flex items-center justify-center'>
        <div className='max-h-screen w-full max-w-xs relative'>
          <div className='bg-legacyColor-secondary-50 rounded-3xl border border-legacyColor-neutral-2-500 p-4 '>
            <div className='p-6'>
              <ul className='list-disc list-inside'>
                <li>The green area indicates interviewer's availability.</li>
                <li>Click on calendar to confirm a time slot.</li>
                <li>
                  Prioritise selecting from interviewer's available slots.
                </li>
                <li>
                  You can also propose a time outside the available slots and
                  wait for interviewer's confirmation.
                </li>
                <li>
                  If you need to make changes after confirming, please contact
                  Talent representative.
                </li>
              </ul>
            </div>
            <div className='text-center w-full pt-2'>
              <button className='btn btn-sm btn-primary' onClick={closeModal}>
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
